import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_membership_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  line_guid: fromDatatype.GuidDataFieldInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  id_user: fromDatatype.VarcharDatatypeInterface;
  id_device: fromDatatype.VarcharDatatypeInterface;
  id_user_agent: fromDatatype.VarcharDatatypeInterface;
  foreign_table: fromDatatype.VarcharDatatypeInterface;
  foreign_key: fromDatatype.VarcharDatatypeInterface;
  trigger_key: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  local_login_guid: fromDatatype.GuidDataFieldInterface;
  local_message_time: fromDatatype.TimestampTzDatatypeInterface;
  local_created_time: fromDatatype.TimestampTzDatatypeInterface;
  local_updated_time: fromDatatype.TimestampTzDatatypeInterface;
  local_deleted_time: fromDatatype.TimestampTzDatatypeInterface;
  local_status: fromDatatype.StatusDataFieldInterface;
  local_device_url: fromDatatype.VarcharDatatypeInterface;
  local_table_name: fromDatatype.VarcharDatatypeInterface;
  local_document_id: fromDatatype.VarcharDatatypeInterface;
  local_db_name: fromDatatype.VarcharDatatypeInterface;
  remote_db_name: fromDatatype.VarcharDatatypeInterface;
  remote_table_name: fromDatatype.VarcharDatatypeInterface;
  remote_device_id: fromDatatype.VarcharDatatypeInterface;
  remote_user_guid: fromDatatype.GuidDataFieldInterface;
  remote_user_id: fromDatatype.VarcharDatatypeInterface;
  remote_message_guid: fromDatatype.GuidDataFieldInterface;
  remote_created_time: fromDatatype.TimestampTzDatatypeInterface;
  remote_device_url: fromDatatype.VarcharDatatypeInterface;
  remote_doc_id: fromDatatype.VarcharDatatypeInterface;
  remote_user_profile_json: fromDatatype.JsonDatatypeInterface;
  doc_json: fromDatatype.JsonDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  app_version: fromDatatype.VarcharDatatypeInterface;
  app_topic: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  reference_number: fromDatatype.VarcharDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;

}

export class bl_crm_membership_event_RowClass implements bl_crm_membership_event_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  line_guid: fromDatatype.GuidDataFieldInterface;
  action: fromDatatype.VarcharDatatypeInterface;
  date_completed: fromDatatype.TimestampTzDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  message_json: fromDatatype.JsonDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  id_user: fromDatatype.VarcharDatatypeInterface;
  id_device: fromDatatype.VarcharDatatypeInterface;
  id_user_agent: fromDatatype.VarcharDatatypeInterface;
  foreign_table: fromDatatype.VarcharDatatypeInterface;
  foreign_key: fromDatatype.VarcharDatatypeInterface;
  trigger_key: fromDatatype.VarcharDatatypeInterface;
  priority: fromDatatype.IntegerDatatypeInterface;
  local_login_guid: fromDatatype.GuidDataFieldInterface;
  local_message_time: fromDatatype.TimestampTzDatatypeInterface;
  local_created_time: fromDatatype.TimestampTzDatatypeInterface;
  local_updated_time: fromDatatype.TimestampTzDatatypeInterface;
  local_deleted_time: fromDatatype.TimestampTzDatatypeInterface;
  local_status: fromDatatype.StatusDataFieldInterface;
  local_device_url: fromDatatype.VarcharDatatypeInterface;
  local_table_name: fromDatatype.VarcharDatatypeInterface;
  local_document_id: fromDatatype.VarcharDatatypeInterface;
  local_db_name: fromDatatype.VarcharDatatypeInterface;
  remote_db_name: fromDatatype.VarcharDatatypeInterface;
  remote_table_name: fromDatatype.VarcharDatatypeInterface;
  remote_device_id: fromDatatype.VarcharDatatypeInterface;
  remote_user_guid: fromDatatype.GuidDataFieldInterface;
  remote_user_id: fromDatatype.VarcharDatatypeInterface;
  remote_message_guid: fromDatatype.GuidDataFieldInterface;
  remote_created_time: fromDatatype.TimestampTzDatatypeInterface;
  remote_device_url: fromDatatype.VarcharDatatypeInterface;
  remote_doc_id: fromDatatype.VarcharDatatypeInterface;
  remote_user_profile_json: fromDatatype.JsonDatatypeInterface;
  doc_json: fromDatatype.JsonDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  app_version: fromDatatype.VarcharDatatypeInterface;
  app_topic: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  reference_number: fromDatatype.VarcharDatatypeInterface;
  event_code: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
}


